
const POOrderHeaderDp = {
        valueExpr: 'id',
        displayExpr: 'code',
        sort: [{ selector: "code", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '3c5fb1b2-589b-4899-8bb5-aaae81f59e9f',
        params: {
            module: "po",
            lookupType: "POOrderHeaderDP",
            showLookupGrid: true,
        },
        columns:  [
            { dataField: "code", caption: "Profile Code", dataType: "string" },
            { dataField: "description", caption: "Description", dataType: "string" },
            { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
            { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
            { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
            { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
            { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
            
        ]
    }

const PORequisitionHeaderDP = {
        valueExpr: 'id',
        displayExpr: 'code',
        sort: [{ selector: "code", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '3c5fb1b2-589b-4899-8bb5-aaae81f59e9f',
        params: {
            module: "po",
            lookupType: "PORequisitionHeaderDP",
            showLookupGrid: true,
        },
        columns:  [
            { dataField: "code", caption: "Profile Code", dataType: "string" },
            { dataField: "description", caption: "Description", dataType: "string" },
            { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible:false},
            { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible:false},
            { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible:false},
            { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible:false},
            { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible:false},
            
        ]
}
export {
    POOrderHeaderDp,
    PORequisitionHeaderDP
}